(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["feature-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-feature-card]').forEach(card => {
      const toggle = card.querySelector('[data-card-toggle]');

      if (! toggle) return;
      


      toggle.addEventListener('click', function(e) {
        e.stopPropagation();
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

        toggle.setAttribute('aria-expanded', ! isExpanded);
        card.setAttribute('aria-expanded', ! isExpanded);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image-comparison"] && !Shopify.designMode) return;
  try {
    class ImageComparison extends HTMLElement {
  constructor() {
    super();
    this.isDragging = false;
    this.containerRect = null;
    this.currentPosition = 50;
  }

  connectedCallback() {
    this.container = this.querySelector('[ref="container"]');
    this.slider = this.querySelector('[ref="slider"]');
    this.overlay = this.querySelector('[ref="overlay"]');

    if (!this.container || !this.slider || !this.overlay) {
      console.error('ImageComparison: Required elements not found');
      return;
    }

    this.initSlider();
  }

  disconnectedCallback() {
    if (this.slider && this.boundHandlers) {
      this.slider.removeEventListener('pointerdown', this.boundHandlers.pointerDown);
    }

    if (this.boundHandlers) {
      document.removeEventListener('pointermove', this.boundHandlers.pointerMove);
      document.removeEventListener('pointerup', this.boundHandlers.pointerUp);
      window.removeEventListener('resize', this.boundHandlers.resize);
    }
  }

  initSlider() {
    // Create and store bound handlers
    this.boundHandlers = {
      pointerDown: this.handlePointerDown.bind(this),
      pointerMove: this.handlePointerMove.bind(this),
      pointerUp: this.handlePointerUp.bind(this),
      resize: this.handleResize.bind(this),
      keyDown: this.handleKeyDown.bind(this)
    };

    // Add slider-specific listeners
    this.slider.addEventListener('pointerdown', this.boundHandlers.pointerDown);
    this.slider.addEventListener('keydown', this.boundHandlers.keyDown);

    // Add document-level listeners
    document.addEventListener('pointermove', this.boundHandlers.pointerMove);
    document.addEventListener('pointerup', this.boundHandlers.pointerUp);
    window.addEventListener('resize', this.boundHandlers.resize);
  }

  handlePointerDown(event) {
    event.preventDefault();
    this.isDragging = true;
    this.containerRect = this.container.getBoundingClientRect();
    this.slider.setPointerCapture(event.pointerId);
  }

  handlePointerMove(event) {
    if (!this.isDragging) return;

    if (!this.containerRect) {
      this.containerRect = this.container.getBoundingClientRect();
    }

    const x = event.clientX - this.containerRect.left;
    const percentage = Math.max(0, Math.min(100, (x / this.containerRect.width) * 100));

    this.updatePosition(percentage);
  }

  handlePointerUp(event) {
    if (!this.isDragging) return;

    this.isDragging = false;
    this.containerRect = null;

    if (event.pointerId !== undefined) {
      this.slider.releasePointerCapture(event.pointerId);
    }
  }

  handleKeyDown(event) {
    let newPosition = this.currentPosition;
    let handled = false;

    switch (event.key) {
      case 'ArrowLeft':
        newPosition = Math.max(0, this.currentPosition - 5);
        handled = true;
        break;
      case 'ArrowRight':
        newPosition = Math.min(100, this.currentPosition + 5);
        handled = true;
        break;
      case 'Home':
        newPosition = 0;
        handled = true;
        break;
      case 'End':
        newPosition = 100;
        handled = true;
        break;
    }

    if (handled) {
      event.preventDefault();
      this.updatePosition(newPosition);
    }
  }

  handleResize() {
    this.containerRect = null;
  }

  updatePosition(percentage) {
    this.currentPosition = percentage;
    const clipValue = 100 - percentage;

    this.slider.style.left = `${percentage}%`;
    this.slider.setAttribute('aria-valuenow', Math.round(percentage).toString());
    this.overlay.style.clipPath = `inset(0 ${clipValue}% 0 0)`;
  }
}

customElements.define('image-comparison', ImageComparison);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["quick-carousel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  for (const carousel of document.querySelectorAll('[data-carousel-wrapper]')) {
    const container = carousel.querySelector('[data-carousel-scroll]');
    const tablist = carousel.querySelector('[data-carousel-tabs]');

    if (!tablist || !container) return;

    const slides = Array.from(container.children);
    const totalSlides = slides.length;

    if (totalSlides === 0) return;

    const carouselId = container.id || `carousel-${Date.now()}`;
    let tabs = [];

    // Add slide attributes
    for (const [i, slide] of slides.entries()) {
      slide.setAttribute('role', 'group');
      slide.setAttribute('aria-roledescription', 'slide');
      slide.setAttribute('aria-label', `${i + 1} of ${totalSlides}`);
      slide.setAttribute('id', `slide-${carouselId}-${i}`);
    }

    // Define functions before using them (function declarations are hoisted)
    function goToSlide(index) {
      slides[index].scrollIntoView({
        behavior: 'smooth',
        inline: 'start',
        block: 'nearest'
      });

      for (const [i, tab] of tabs.entries()) {
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
        tab.setAttribute('tabindex', i === index ? '0' : '-1');
      }
    }

    function handleTabKeyPress(event) {
      const currentIndex = tabs.indexOf(event.target);
      let nextIndex;

      switch (event.key) {
        case 'ArrowLeft':
          event.preventDefault();
          nextIndex = currentIndex > 0 ? currentIndex - 1 : totalSlides - 1;
          tabs[nextIndex].focus();
          goToSlide(nextIndex);
          break;
        case 'ArrowRight':
          event.preventDefault();
          nextIndex = currentIndex < totalSlides - 1 ? currentIndex + 1 : 0;
          tabs[nextIndex].focus();
          goToSlide(nextIndex);
          break;
        case 'Home':
          event.preventDefault();
          tabs[0].focus();
          goToSlide(0);
          break;
        case 'End':
          event.preventDefault();
          tabs[totalSlides - 1].focus();
          goToSlide(totalSlides - 1);
          break;
      }
    }

    // Create tabs
    for (const [i, slide] of slides.entries()) {
      const tab = document.createElement('button');
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      tab.setAttribute('aria-controls', `slide-${carouselId}-${i}`);
      tab.setAttribute('aria-label', `Go to slide ${i + 1}`);
      tab.setAttribute('tabindex', i === 0 ? '0' : '-1');

      tab.addEventListener('click', (e) => {
        e.preventDefault();
        goToSlide(i);
      });
      tab.addEventListener('keydown', handleTabKeyPress);

      tablist.appendChild(tab);
    }

    tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));

    // Update active tab on scroll
    container.addEventListener('scroll', () => {
      const scrollPos = container.scrollLeft;
      const slideWidth = slides[0].offsetWidth + parseFloat(getComputedStyle(container).gap);
      const activeIndex = Math.round(scrollPos / slideWidth);

      for (const [i, tab] of tabs.entries()) {
        tab.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
        tab.setAttribute('tabindex', i === activeIndex ? '0' : '-1');
      }
    });
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sd_hotspot"] && !Shopify.designMode) return;
  try {
    class HotspotBlock extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.hotspot__trigger');
      this.card = this.querySelector('.hotspot__card');
      this.triggerMode = this.dataset.trigger || 'click';
      this.entranceAnimation = this.dataset.entranceAnimation === 'true';

      if (this.trigger && this.card) {
        // Only add click handlers for click mode
        if (this.triggerMode === 'click') {
          this.trigger.addEventListener('click', this.toggle.bind(this));
          document.addEventListener('click', this.handleClickOutside.bind(this));
          document.addEventListener('keydown', this.handleEscape.bind(this));
        }

        // For hover mode, ensure trigger is accessible but no click action needed
        if (this.triggerMode === 'hover') {
          this.trigger.setAttribute('aria-expanded', 'false');
          this.trigger.addEventListener('mouseenter', () => this.adjustCardPosition());
        }

        // For always visible mode, set to expanded
        if (this.triggerMode === 'always') {
          this.trigger.setAttribute('aria-expanded', 'true');
        }

        // Position on load too: a closed card near the edge still widens the page on mobile
        this.adjustCardPosition();
        window.addEventListener('resize', () => this.adjustCardPosition());

        // Setup entrance animation observer
        if (this.entranceAnimation) {
          this.setupEntranceAnimation();
        } else {
          // If no entrance animation, make visible immediately
          this.classList.add('hotspot--visible');
        }
      }
    }

    setupEntranceAnimation() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.hasAnimated) {
              this.classList.add('hotspot--visible');
              this.hasAnimated = true;
              observer.unobserve(this);
            }
          });
        },
        {
          threshold: 0.2,
          rootMargin: '0px 0px -50px 0px'
        }
      );

      observer.observe(this);
    }

    adjustCardPosition() {
      if (!this.card) return;

      // Get the parent section that contains this hotspot
      const section = this.closest('section, .shopify-section');
      if (!section) return;

      const sectionRect = section.getBoundingClientRect();
      const triggerRect = this.trigger.getBoundingClientRect();
      const cardRect = this.card.getBoundingClientRect();
      const isMobile = window.innerWidth < 750;

      if (isMobile) {
        // Mobile: check if card would overflow bottom of viewport
        const spaceBelow = window.innerHeight - triggerRect.bottom;

        if (spaceBelow < cardRect.height + 20) {
          this.card.classList.add('hotspot__card--flip-vertical');
        } else {
          this.card.classList.remove('hotspot__card--flip-vertical');
        }

        // The card centres on the hotspot, so near a side it runs off screen. Slide it
        // back inside a 20px gutter (matches the max-width above).
        const gutter = 20;
        const cardWidth = this.card.offsetWidth;
        if (!cardWidth) return; // not laid out yet (closed accordion, hidden tab); open/resize redo this
        const centredLeft = triggerRect.left + triggerRect.width / 2 - cardWidth / 2;
        const maxLeft = document.documentElement.clientWidth - gutter - cardWidth;
        const left = Math.min(Math.max(centredLeft, gutter), maxLeft);
        this.card.style.setProperty('--card-offset-x', `${left - centredLeft}px`);
      } else {
        // Desktop: check section boundaries
        const spaceRight = sectionRect.right - triggerRect.right;
        const spaceBottom = sectionRect.bottom - triggerRect.bottom;

        // Flip horizontal if not enough space on right
        if (spaceRight < cardRect.width + 20) {
          this.card.classList.add('hotspot__card--flip-horizontal');
        } else {
          this.card.classList.remove('hotspot__card--flip-horizontal');
        }

        // Flip vertical if not enough space on bottom
        if (spaceBottom < cardRect.height / 2) {
          this.card.classList.add('hotspot__card--flip-vertical');
        } else {
          this.card.classList.remove('hotspot__card--flip-vertical');
        }
      }
    }

    toggle(event) {
      event.stopPropagation();
      const isExpanded = this.trigger.getAttribute('aria-expanded') === 'true';
      this.trigger.setAttribute('aria-expanded', !isExpanded);
      this.card.classList.toggle('hotspot__card--open');

      // Adjust position when opening
      if (!isExpanded) {
        setTimeout(() => this.adjustCardPosition(), 10);
      }
    }

    handleClickOutside(event) {
      if (!this.contains(event.target)) {
        this.close();
      }
    }

    handleEscape(event) {
      if (event.key === 'Escape') {
        this.close();
      }
    }

    close() {
      this.trigger.setAttribute('aria-expanded', 'false');
      this.card.classList.remove('hotspot__card--open');
    }
  }

  customElements.define('hotspot-block', HotspotBlock);
  } catch(e) { console.error(e); }
})();

})();
